import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/components/ui/use-toast";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { ScrollReveal } from "./ScrollReveal";
import { Send } from "lucide-react";
import axios from "axios";

export const ContactForm = () => {
  const { toast } = useToast();
  const [eventType, setEventType] = useState("firmowe");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    try {
      await axios({
        method: "POST",
        url: 'https://form.aigency.pl/api/form',
        data: {
          website: 'WystepKabaretu.pl',
          email: formData.get("email"),
          destinationEmail: 'kontakt@wystepkabaretu.pl',
          fields: {
            "Imię i nazwisko": formData.get("name"),
            "Numer telefonu": formData.get("phone"),
            "Rodzaj wydarzenia": eventType,
            "Wiadomość": formData.get("message"),
          }
        }
      });

      form.reset();
      toast({
        title: "Formularz wysłany!",
        description: "Skontaktujemy się z Tobą najszybciej jak to możliwe.",
      });
    } catch {
      toast({
        title: "Błąd wysyłania formularza"
      });
    }
  };

  return (
    <section className="py-24 bg-background" id="kontakt">
      <div className="container max-w-2xl">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest">Kontakt</span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              Zamów występ
            </h2>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={200}>
          <form onSubmit={handleSubmit} className="space-y-6 glass-light p-8 md:p-10 rounded-2xl shadow-xl">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="font-inter text-sm font-medium mb-2 block text-foreground">Imię i nazwisko</label>
                <Input name="name" required className="rounded-xl border-border/50 focus:border-accent" />
              </div>
              <div>
                <label className="font-inter text-sm font-medium mb-2 block text-foreground">Email</label>
                <Input name="email" type="email" required className="rounded-xl border-border/50 focus:border-accent" />
              </div>
            </div>

            <div>
              <label className="font-inter text-sm font-medium mb-2 block text-foreground">Numer telefonu</label>
              <Input name="phone" type="tel" required className="rounded-xl border-border/50 focus:border-accent" />
            </div>

            <div className="space-y-3">
              <label className="font-inter text-sm font-medium block text-foreground">Rodzaj wydarzenia</label>
              <RadioGroup defaultValue="firmowe" onValueChange={setEventType}>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="firmowe" id="firmowe" />
                  <Label htmlFor="firmowe">Wydarzenie firmowe</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="prywatne" id="prywatne" />
                  <Label htmlFor="prywatne">Impreza prywatna</Label>
                </div>
              </RadioGroup>
            </div>

            <div>
              <label className="font-inter text-sm font-medium mb-2 block text-foreground">Wiadomość</label>
              <Textarea name="message" required className="min-h-[150px] rounded-xl border-border/50 focus:border-accent" />
            </div>

            <Button
              type="submit"
              className="w-full bg-accent text-accent-foreground hover:bg-accent/90 rounded-full py-6 text-lg font-bold shadow-lg shadow-accent/25 hover:shadow-accent/40 transition-all flex items-center justify-center gap-2"
            >
              <Send className="w-5 h-5" />
              Wyślij zapytanie
            </Button>
          </form>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <div className="mt-16 text-center">
            <div className="inline-block glass-light rounded-2xl px-8 py-6 shadow-md">
              <p className="text-xs uppercase tracking-widest text-accent font-semibold mb-3">Właścicielem serwisu jest</p>
              <p className="font-montserrat font-bold text-foreground text-lg">Wirtualny Biznes</p>
              <p className="text-muted-foreground text-sm mt-1">ul. Księcia Witolda 49/15, 50-202 Wrocław</p>
              <p className="text-muted-foreground text-sm">NIP: 8961619199</p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
